import { cn } from "@/lib/utils";
import type { CopilotStatus } from "./StatusDot";

const statusValueColors: Record<CopilotStatus, string> = {
  critical: "text-copilot-critical",
  warning: "text-copilot-warning",
  healthy: "text-copilot-healthy",
  neutral: "text-copilot-neutral",
};

interface CountCardProps {
  count: number;
  label: string;
  status: CopilotStatus;
  active?: boolean;
  onClick?: () => void;
}

export function CountCard({ count, label, status, active, onClick }: CountCardProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "text-center p-[var(--space-md)] py-3 bg-copilot-surface-sunken rounded-lg border border-copilot-neutral-border",
        "cursor-pointer transition-all",
        "hover:border-copilot-text-tertiary",
        active && "border-copilot-brand bg-copilot-brand-bg"
      )}
    >
      <div className={cn("text-[22px] font-bold", statusValueColors[status])}>
        {count}
      </div>
      <div className="text-[var(--overline-size)] text-copilot-text-secondary mt-0.5">
        {label}
      </div>
    </button>
  );
}
